import { Grid2, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { assertString, validEmailRegex } from "core/validation";
import PropTypes from "prop-types";
import React, { useState } from "react";

function SimpleContact({ defaultContact, onSave, onClose, onAdd }) {
    const [contact, setContact] = useState(defaultContact);
    const [error, setError] = useState({});
    const [textError, setTextError] = useState({});

    function handleChange(e) {
        const el = {
            [e.target.name]: e.target.value,
        };
        setContact({ ...contact, ...el });
    }

    function validate() {
        let error = {};
        let textError = {};
        if (!assertString(contact.name) || contact.name.length < 3) {
            error.name = true;
            textError.name = "Invalid name";
        }
        if (!assertString(contact.lastName) || contact.lastName.length < 3) {
            error.lastName = true;
            textError.lastName = "Invalid name";
        }
        if (!assertString(contact.email) || !contact.email.match(validEmailRegex)) {
            error.email = true;
            textError.email = "Invalid email";
        }
        setError(error);
        setTextError(textError);
        return error;
    }
    function handleAdd() {
        const error = validate();
        if (Object.keys(error).length === 0) {
            onAdd(contact);
        }
    }

    function handleSave() {
        const error = validate();
        if (Object.keys(error).length === 0) {
            onSave(contact);
        }
    }

    function handleClose() {
        onClose();
    }
    return (
        (<Box p={4} style={{ maxWidth: 400 }}>
            <Grid2 container spacing={4} direction={"row"}>
                <Grid2 size={12}>
                    <TextField
                        variant={"outlined"}
                        name={"name"}
                        label={"First Name"}
                        value={contact.name}
                        onChange={handleChange}
                        placeholder="First Name"
                        error={error.name}
                        helperText={textError.name}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <TextField
                        variant={"outlined"}
                        name={"lastName"}
                        label={"Last Name"}
                        value={contact.lastName}
                        onChange={handleChange}
                        placeholder="Last Name"
                        error={error.lastName}
                        helperText={textError.lastName}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <TextField
                        variant={"outlined"}
                        name={"email"}
                        label={"Email"}
                        value={contact.email}
                        onChange={handleChange}
                        placeholder="Email"
                        error={error.email}
                        helperText={textError.email}
                    />
                </Grid2>
                <Grid2 style={{ textAlign: "right" }} size={12}>
                    <Button color={"default"} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button color={"primary"} onClick={handleAdd}>
                        Add
                    </Button>
                    <Button color={"secondary"} onClick={handleSave}>
                        Add and create
                    </Button>
                </Grid2>
            </Grid2>
        </Box>)
    );
}

SimpleContact.propTypes = {
    defaultContact: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
};

export default SimpleContact;
